import { useEffect, useCallback } from 'react';
import { getScopeElements, getFocusables, priorityFocusableSelector, } from './utils';
export const useAutoFocus = (props) => {
    const { scope, enabled = true } = props;
    const autoFocus = useCallback(() => {
        var _a, _b;
        if (!enabled)
            return;
        const elements = getScopeElements(scope);
        if (elements.length === 0)
            return;
        // Do not auto focus on wrappers, buttons and so on, if input exist
        const priorityFocusable = (_a = getFocusables(elements, priorityFocusableSelector)) === null || _a === void 0 ? void 0 : _a.first;
        const focusElement = priorityFocusable
            ? priorityFocusable
            : (_b = getFocusables(elements)) === null || _b === void 0 ? void 0 : _b.first;
        focusElement === null || focusElement === void 0 ? void 0 : focusElement.focus(preventScroll);
    }, [enabled, scope]);
    useEffect(autoFocus, [enabled, scope]); // eslint-disable-line
};
const preventScroll = { preventScroll: true };
//# sourceMappingURL=useAutoFocus.js.map